import React, { useState, useEffect } from 'react';
import { API } from '../../services/api';
import InviteMemberModal from './InviteMemberModal';
import './InvitationsSection.css';

function InvitationsSection({ organizationId }) {
    const [invitations, setInvitations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showInviteModal, setShowInviteModal] = useState(false);

    useEffect(() => {
        loadInvitations();
    }, [organizationId]);

    const loadInvitations = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await API.getOrganizationInvitations(organizationId);
            if (response && response.data) {
                setInvitations(response.data.invitations || []);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleRevokeInvitation = async (invitationId, email) => {
        if (!window.confirm(`Êtes-vous sûr de vouloir révoquer l'invitation de ${email} ?`)) {
            return;
        }

        try {
            await API.revokeInvitation(organizationId, invitationId);
            await loadInvitations();
        } catch (error) {
            alert(error.message);
        }
    };

    const handleInviteSuccess = () => {
        setShowInviteModal(false);
        loadInvitations();
    };

    const copyInvitationLink = (token) => {
        const link = `${window.location.origin}/accept-invitation/${token}`;
        navigator.clipboard.writeText(link);
        alert('Lien d\'invitation copié !');
    };

    if (loading) {
        return <div className="invitations-loading">Chargement des invitations...</div>;
    }

    if (error) {
        return <div className="invitations-error">Erreur : {error}</div>;
    }

    return (
        <div className="invitations-section">
            <div className="invitations-header">
                <h2>Invitations en attente ({invitations.length})</h2>
                <button className="btn-primary" onClick={() => setShowInviteModal(true)}>
                    Inviter un membre
                </button>
            </div>

            {invitations.length === 0 ? (
                <div className="no-invitations">
                    <p>Aucune invitation en attente</p>
                    <button className="btn-secondary" onClick={() => setShowInviteModal(true)}>
                        Inviter un membre
                    </button>
                </div>
            ) : (
                <div className="invitations-table-container">
                    <table className="invitations-table">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Rôle</th>
                                <th>Invité par</th>
                                <th>Date d'envoi</th>
                                <th>Expire le</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invitations.map(invitation => {
                                const isExpired = new Date(invitation.expires_at) < new Date();
                                return (
                                    <tr key={invitation.id} className={isExpired ? 'expired' : ''}>
                                        <td>
                                            <div className="invitation-email">{invitation.email}</div>
                                        </td>
                                        <td>
                                            <span className="role-badge">{invitation.role}</span>
                                        </td>
                                        <td>{invitation.invited_by_email}</td>
                                        <td>{new Date(invitation.created_at).toLocaleDateString('fr-FR')}</td>
                                        <td>
                                            <span className={isExpired ? 'expired-badge' : ''}>
                                                {new Date(invitation.expires_at).toLocaleDateString('fr-FR')}
                                                {isExpired && ' (expirée)'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="invitation-actions">
                                                <button
                                                    className="btn-revoke"
                                                    onClick={() => handleRevokeInvitation(invitation.id, invitation.email)}
                                                    title="Révoquer cette invitation"
                                                >
                                                    Révoquer
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {showInviteModal && (
                <InviteMemberModal
                    organizationId={organizationId}
                    onClose={() => setShowInviteModal(false)}
                    onSuccess={handleInviteSuccess}
                />
            )}
        </div>
    );
}

export default InvitationsSection;
